import React from 'react';
import { FiTrendingUp, FiAlertCircle } from 'react-icons/fi';
import { WidgetDef } from '../types';
import { useWidgetSite } from '../shared';

// spec 621:4886 — no settings: price and change only, the rest lives in Capital structure
const sharePrice: WidgetDef = {
    slug: 'share-price',
    name: 'Share price',
    description: 'Live ASX price, change and the day’s range',
    icon: <FiTrendingUp />,
    title: 'Share Price Widget',
    installed: true,
    page: '/investors/investors-dashboard/',
    views: 1240,
    summary: 'On /investors/investors-dashboard/ · price and change only, no chart',
    getCodeButton: true,
    demoPath: '/investors/investors-dashboard/',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_share_price instance="share-price"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="share-price" class="investi-share-price"></div>', dark: true },
    ],
    Demo: () => {
        const { ticker } = useWidgetSite();
        return <div className="wd-share-price">
            <div className="wd-demo-head"><h3>{ticker} share price</h3><p>ASX: {ticker}</p></div>
            <div className="price-row">
                <strong>A$0.245</strong>
                <span className="chip up">▲ 4.3%</span>
                <span className="chip up">+A$0.010</span>
            </div>
            <p className="muted">Updated 3 Sep 2026, 2:41 pm AWST</p>
            <p className="muted small">Market data prices are at least 20 minutes delayed</p>
            <div className="wd-info"><FiAlertCircle /> Open, day range, volume, 52‑week range and market cap now live in the Capital structure widget.</div>
        </div>;
    },
};

export default sharePrice;
